import React from 'react';
import Store from './store';
import GettingStarted from './components/GettingStarted';

export default props => (
  <Store>
    <GettingStarted {...props} />
  </Store>
);



// WEBPACK FOOTER //
// ./app/javascript/components/getting_started/index.js